import { maxLength, helpers } from '@vuelidate/validators'

export const workRules = {
  targetWorks: {
    $each: helpers.forEach({
      offer_note: { maxLength: maxLengthWithMessage(40) },
      entry_note: { maxLength: maxLengthWithMessage(40) }
    })
  }
}

function maxLengthWithMessage(count) {
  return helpers.withMessage(
    `${count}文字以下で入力してください`,
    maxLength(count)
  )
}
